"use strict";

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es6.date.to-string");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.reflect.construct");

require("core-js/modules/es6.object.assign");

var _classCallCheck = require("/home/sam/Desktop/projects/startups/explot/app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/sam/Desktop/projects/startups/explot/app/node_modules/@babel/runtime/helpers/createClass");

var _inherits = require("/home/sam/Desktop/projects/startups/explot/app/node_modules/@babel/runtime/helpers/inherits");

var _possibleConstructorReturn = require("/home/sam/Desktop/projects/startups/explot/app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/home/sam/Desktop/projects/startups/explot/app/node_modules/@babel/runtime/helpers/getPrototypeOf");

require("core-js/modules/es6.object.define-property");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

Object.defineProperty(exports, "__esModule", {
  value: true
});

var tslib_1 = require("tslib");

var React = tslib_1.__importStar(require("react"));

var dropdown_1 = tslib_1.__importDefault(require("@patternfly/react-styles/css/components/Dropdown/dropdown"));

var react_styles_1 = require("@patternfly/react-styles");

var DropdownToggleAction = /*#__PURE__*/function (_React$Component) {
  _inherits(DropdownToggleAction, _React$Component);

  var _super = _createSuper(DropdownToggleAction);

  function DropdownToggleAction() {
    _classCallCheck(this, DropdownToggleAction);

    return _super.apply(this, arguments);
  }

  _createClass(DropdownToggleAction, [{
    key: "render",
    value: function render() {
      var _a = this.props,
          id = _a.id,
          className = _a.className,
          onClick = _a.onClick,
          isDisabled = _a.isDisabled,
          children = _a.children,
          props = tslib_1.__rest(_a, ["id", "className", "onClick", "isDisabled", "children"]);

      return React.createElement("button", Object.assign({
        id: id,
        className: react_styles_1.css(dropdown_1["default"].dropdownToggleButton, className),
        onClick: onClick
      }, isDisabled && {
        disabled: true,
        'aria-disabled': true
      }, props), children);
    }
  }]);

  return DropdownToggleAction;
}(React.Component);

exports.DropdownToggleAction = DropdownToggleAction;
DropdownToggleAction.displayName = 'DropdownToggleAction';
DropdownToggleAction.defaultProps = {
  className: '',
  isDisabled: false,
  onClick: function onClick() {}
};